module.exports = __webpack_public_path__ + "static/media/home-web.6bf3b9a8.6bf3b9a8.JPG";